export const guardGroup = {
    name: '',
    vigilants: [],
    account: '',
    client: '',
    site: '',
    status: 'ACTIVE',
}
